export const API_ENDPOINTS = {
  GET_CURRENT_ORGANIZATION: '/organizations/current/',
  UPDATE_ORGANIZATION: '/organizations/current/',
  DELETE_ORGANIZATION: '/organizations/current/',
} as const;

export const ORGANIZATION_SIZE_OPTIONS = [
  { value: '1-10', label: '1-10 Mitarbeiter' },
  { value: '11-50', label: '11-50 Mitarbeiter' },
  { value: '51-100', label: '51-100 Mitarbeiter' },
  { value: '101-500', label: '101-500 Mitarbeiter' },
  { value: '501-1000', label: '501-1000 Mitarbeiter' },
  { value: '1000+', label: '1000+ Mitarbeiter' },
];

export const INDUSTRY_OPTIONS = [
  { value: 'Technology', label: 'Technologie' },
  { value: 'Healthcare', label: 'Gesundheitswesen' },
  { value: 'Finance', label: 'Finanzwesen' },
  { value: 'Education', label: 'Bildung' },
  { value: 'Retail', label: 'Einzelhandel' },
  { value: 'Manufacturing', label: 'Produktion' },
  { value: 'Consulting', label: 'Beratung' },
  { value: 'Other', label: 'Sonstiges' },
];

export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'suspended', label: 'Suspended' },
];

export const COUNTRY_OPTIONS = [
  { value: '', label: 'Select Country' },
  { value: 'Germany', label: 'Deutschland' },
  //{ value: 'Austria', label: 'Österreich' },
];

export const PLAN_OPTIONS = [
  { value: 'free', label: 'Free' },
  { value: 'basic', label: 'Basic' },
  { value: 'premium', label: 'Premium' },
  { value: 'enterprise', label: 'Enterprise' },
];

// Common timezones - IANA timezone identifiers
export const TIMEZONE_OPTIONS = [
  { value: 'UTC', label: 'UTC - Koordinierte Weltzeit' },
  { value: 'America/New_York', label: 'Amerika, New York (UTC-5/-4)' },
  { value: 'America/Chicago', label: 'Amerika, Chicago (UTC-6/-5)' },
  { value: 'America/Denver', label: 'Amerika, Denver (UTC-7/-6)' },
  { value: 'America/Los_Angeles', label: 'Amerika, Los Angeles (UTC-8/-7)' },
  { value: 'America/Phoenix', label: 'Amerika, Phoenix (UTC-7)' },
  { value: 'America/Anchorage', label: 'Amerika, Anchorage (UTC-9/-8)' },
  { value: 'America/Honolulu', label: 'Amerika, Honolulu (UTC-10)' },
  { value: 'Europe/London', label: 'Europa, London (UTC+0/+1)' },
  { value: 'Europe/Paris', label: 'Europa, Paris (UTC+1/+2)' },
  { value: 'Europe/Berlin', label: 'Europa, Berlin (UTC+1/+2)' },
  { value: 'Europe/Rome', label: 'Europa, Rom (UTC+1/+2)' },
  { value: 'Europe/Madrid', label: 'Europa, Madrid (UTC+1/+2)' },
  { value: 'Europe/Amsterdam', label: 'Europa, Amsterdam (UTC+1/+2)' },
  { value: 'Europe/Brussels', label: 'Europa, Brüssel (UTC+1/+2)' },
  { value: 'Europe/Vienna', label: 'Europa, Wien (UTC+1/+2)' },
  { value: 'Europe/Zurich', label: 'Europa, Zürich (UTC+1/+2)' },
  { value: 'Europe/Stockholm', label: 'Europa, Stockholm (UTC+1/+2)' },
  { value: 'Europe/Copenhagen', label: 'Europa, Kopenhagen (UTC+1/+2)' },
  { value: 'Europe/Oslo', label: 'Europa, Oslo (UTC+1/+2)' },
  { value: 'Europe/Helsinki', label: 'Europa, Helsinki (UTC+2/+3)' },
  { value: 'Europe/Warsaw', label: 'Europa, Warschau (UTC+1/+2)' },
  { value: 'Europe/Prague', label: 'Europa, Prag (UTC+1/+2)' },
  { value: 'Europe/Budapest', label: 'Europa, Budapest (UTC+1/+2)' },
  { value: 'Europe/Athens', label: 'Europa, Athen (UTC+2/+3)' },
  { value: 'Europe/Istanbul', label: 'Europa, Istanbul (UTC+3)' },
  { value: 'Europe/Moscow', label: 'Europa, Moskau (UTC+3)' },
  { value: 'Asia/Dubai', label: 'Asien, Dubai (UTC+4)' },
  { value: 'Asia/Karachi', label: 'Asien, Karatschi (UTC+5)' },
  { value: 'Asia/Kolkata', label: 'Asien, Mumbai (UTC+5:30)' },
  { value: 'Asia/Dhaka', label: 'Asien, Dhaka (UTC+6)' },
  { value: 'Asia/Bangkok', label: 'Asien, Bangkok (UTC+7)' },
  { value: 'Asia/Singapore', label: 'Asien, Singapur (UTC+8)' },
  { value: 'Asia/Hong_Kong', label: 'Asien, Hongkong (UTC+8)' },
  { value: 'Asia/Shanghai', label: 'Asien, Shanghai (UTC+8)' },
  { value: 'Asia/Tokyo', label: 'Asien, Tokio (UTC+9)' },
  { value: 'Asia/Seoul', label: 'Asien, Seoul (UTC+9)' },
  { value: 'Australia/Sydney', label: 'Australien, Sydney (UTC+10/+11)' },
  { value: 'Australia/Melbourne', label: 'Australien, Melbourne (UTC+10/+11)' },
  { value: 'Australia/Brisbane', label: 'Australien, Brisbane (UTC+10)' },
  { value: 'Australia/Perth', label: 'Australien, Perth (UTC+8)' },
  { value: 'Pacific/Auckland', label: 'Pazifik, Auckland (UTC+12/+13)' },
  { value: 'America/Sao_Paulo', label: 'Südamerika, São Paulo (UTC-3)' },
  { value: 'America/Buenos_Aires', label: 'Südamerika, Buenos Aires (UTC-3)' },
  { value: 'America/Mexico_City', label: 'Nordamerika, Mexiko-Stadt (UTC-6/-5)' },
  { value: 'America/Toronto', label: 'Nordamerika, Toronto (UTC-5/-4)' },
  { value: 'America/Vancouver', label: 'Nordamerika, Vancouver (UTC-8/-7)' },
  { value: 'Africa/Johannesburg', label: 'Afrika, Johannesburg (UTC+2)' },
  { value: 'Africa/Cairo', label: 'Afrika, Kairo (UTC+2)' },
  { value: 'Asia/Jerusalem', label: 'Asien, Jerusalem (UTC+2/+3)' },
  { value: 'Asia/Riyadh', label: 'Asien, Riad (UTC+3)' },
];
